"use client"

import React from 'react';
import { Table as CTable, Empty, TablePaginationConfig } from 'antd';
import { mapModifiers } from '@/utils/funtion';
import { SizeType } from 'antd/lib/config-provider/SizeContext';

interface TableProps {
    columns?: any;
    dataSource?: any;
    title?: (data: any) => React.ReactNode;
    isHideHeader?: boolean;
    bordered?: boolean;
    scroll?: object;
    pagination?: false | TablePaginationConfig | undefined;
    sticky?: boolean;
    className?: string;
    childrenColumnName?: string;
    loading?: boolean;
    isExpandable?: boolean;
    size?: SizeType;
}

const Table: React.FC<TableProps> = ({ 
    columns, dataSource, title, isHideHeader, scroll, bordered, pagination, sticky, className, loading, size,
    childrenColumnName='children',isExpandable
 }) => (
    <div className={mapModifiers('m-table', isHideHeader && 'hide_header', className)}>
        <CTable
            dataSource={dataSource}
            columns={columns}
            title={title}
            locale={{ emptyText: <Empty description="Không có dữ liệu ...!" /> }}
            scroll={scroll}
            bordered={bordered}
            pagination={pagination}
            sticky={sticky}
            loading={loading}
            size={size || 'middle'}
            expandable={isExpandable? {
                childrenColumnName:childrenColumnName
            }: undefined}
        />
    </div>
);

export default Table;
